import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from 'react';
import { translate } from '@openclassrooms/translations';
import { ROUTES } from '@openclassrooms/routing';
import { styled } from '@classify/react-core-components/styles';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import FooterLinkItem from './FooterLinkItem';
declare global {
  interface Window {
    truste?: {
      eu?: {
        clickListener: () => void;
      };
    };
  }
}
const List = styled('ul')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  marginBottom: spacing(2),
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  margin: spacing(4, 0),
  padding: 0,
  columnGap: spacing(4),
  rowGap: spacing(1),
  position: 'relative',
  '&::before': {
    content: '""',
    width: '100%',
    top: -16,
    borderTop: `1px solid ${palette.divider}`,
    position: 'absolute'
  }
}));
export default function FooterPolicies() {
  const $ = _c(22);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const handleCookieClick = _temp;
  let t0;
  if ($[0] !== getLocalisationConfig) {
    t0 = getLocalisationConfig("page.policies_specific_country.url");
    $[0] = getLocalisationConfig;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const specificCountryUrl = t0;
  let t1;
  if ($[2] !== getLocalisationConfig) {
    t1 = getLocalisationConfig("apprenticeship.agreement.url");
    $[2] = getLocalisationConfig;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const apprenticeshipAgreementUrl = t1;
  let t2;
  if ($[4] !== getLocalisationConfig) {
    t2 = getLocalisationConfig("page.accessibility-declaration.url");
    $[4] = getLocalisationConfig;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const accessibilityDeclarationUrl = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208.2 15.8" width="208" fill="var(--clf-brand-official)" aria-hidden="true"><path d="M126.5 10.8c0 .9-.2 1.8-.7 2.5-.5.7-1.2 1.3-2.1 1.8-1 .4-2.1.7-3.5.7-1.2 0-2.3-.1-3.4-.4-1.1-.3-2-.7-2.7-1.2l2.2-2.6c.4.2.9.4 1.4.6.9.3 1.7.4 2.5.4 1.5 0 2.4-.4 2.4-1.2 0-.4-.2-.7-.7-1-.4-.2-1.2-.4-2.1-.7-1.1-.2-2-.5-2.7-.8-.7-.3-1.3-.7-1.9-1.3-.5-.6-.8-1.5-.8-2.5s.2-1.8.7-2.5c.5-.7 1.2-1.3 2.1-1.8 1-.4 2.1-.7 3.5-.7 1 0 1.9.1 2.8.4 1 .2 1.8.6 2.4 1l-2.3 2.7c-1-.4-2.1-.7-3-.7-.8 0-1.4.1-1.8.4-.4.2-.6.6-.6 1s.2.7.7.9c.4.2 1.2.4 2.1.7.9.2 1.8.5 2.7.8.7.3 1.3.7 1.9 1.3.6.3.9 1.2.9 2.2zm81.6 0c0 .9-.2 1.8-.7 2.5s-1.2 1.3-2.1 1.8c-1 .4-2.1.7-3.5.7-1.2 0-2.3-.1-3.4-.4-1.1-.3-2-.7-2.7-1.2l2.2-2.6c.4.2.9.4 1.4.6.9.3 1.7.4 2.5.4 1.5 0 2.4-.4 2.4-1.2 0-.4-.2-.7-.7-1-.4-.2-1.2-.4-2.1-.7-.9-.2-1.8-.5-2.7-.8-.7-.3-1.3-.7-1.9-1.3-.5-.6-.8-1.5-.8-2.5s.2-1.8.7-2.5c.5-.7 1.2-1.3 2.1-1.8 1-.4 2.1-.7 3.5-.7 1 0 1.9.1 2.8.4 1 .2 1.8.6 2.4 1l-2.3 2.7c-1-.4-2.1-.7-3-.7-.8 0-1.4.1-1.8.4-.4.2-.6.6-.6 1s.2.7.7.9c.4.2 1.2.4 2.1.7.9.2 1.8.5 2.7.8.7.3 1.3.7 1.9 1.3.7.3.9 1.2.9 2.2zm-180.6-5a5.1 5.1 0 0 1-3 4.8c-1 .4-2.1.7-3.4.7h-2.5v4h-4.1V.1h6.6c1.3 0 2.4.2 3.4.7 1 .4 1.7 1.1 2.2 2 .5.9.8 1.9.8 3zm-4.2 0c0-.7-.2-1.2-.7-1.6-.4-.4-1-.6-1.9-.6h-2.3v4.5h2.3c.8 0 1.5-.2 1.9-.6.5-.3.7-.9.7-1.7zm17.4 6.3v3.3H29.2V.3h11.3v3.3h-7.2v2.6H39v3.2h-5.8v2.8l7.5-.1zM56.4.3v15.1H53l-6.4-8.1v8.1h-4.1V.3h3.4l6.4 8.1V.3h4.1zM82.6 12v3.4H72.3V.2h4.1v11.7l6.2.1zm17.7 3.4H96l-1.1-2.9h-6.1l-1.1 2.9h-4.2L89.9.3H94l6.3 15.1zm-6.6-6.1-1.8-4.8L90 9.3h3.7zm19.5 1.5c0 .9-.2 1.8-.7 2.5-.5.7-1.2 1.3-2.1 1.8-1 .4-2.1.7-3.5.7-1.2 0-2.3-.1-3.4-.4s-2-.7-2.7-1.2l2.2-2.6c.4.2.9.4 1.4.6.9.3 1.7.4 2.5.4 1.5 0 2.4-.4 2.4-1.2 0-.4-.2-.7-.7-1-.4-.2-1.2-.4-2.1-.7-1.1-.2-2-.5-2.7-.8-.7-.3-1.3-.7-1.9-1.3-.5-.6-.8-1.5-.8-2.5s.2-1.8.7-2.5c.5-.7 1.2-1.3 2.1-1.8 1-.4 2.1-.7 3.5-.7 1 0 1.9.1 2.8.4 1 .2 1.7.6 2.4 1l-2.3 2.7c-1-.4-2.1-.7-3-.7-.8 0-1.4.1-1.8.4-.4.2-.6.6-.6 1s.2.7.7.9c.4.2 1.2.4 2.1.7.9.2 1.8.5 2.7.8.7.3 1.3.7 1.9 1.3.6.3.9 1.2.9 2.2zm-100.5-3A7.94 7.94 0 0 1 .1 14.2L2.8 11a3.78 3.78 0 0 0 5.8-3.1 3.78 3.78 0 0 0-5.8-3.1L.1 1.6C1.4.6 3.1.1 4.7.1c4.5-.1 8 3.4 8 7.7zM68 11l2.7 3.1c-1.3 1-3 1.5-4.6 1.5-4.4 0-8-3.5-8-7.9a7.94 7.94 0 0 1 12.6-6.4L68 4.6a3.78 3.78 0 0 0-5.8 3.1c0 2 1.7 3.7 3.8 3.7.8.2 1.4 0 2-.4zm73.6 4.4-3.2-4.7c1-.4 1.6-1.1 2.1-1.9a5.83 5.83 0 0 0 0-5.9c-.5-.9-1.3-1.5-2.2-2-1-.4-2.1-.7-3.4-.7h-6.6v15.1h4.1v-4h1.9l2.7 4 4.6.1zm-9.3-11.8h2.4c.8 0 1.5.2 1.9.6.4.4.7 1 .7 1.6 0 .7-.2 1.2-.7 1.6-.4.4-1 .6-1.9.6h-2.4V3.6zM150.8 0c4.4 0 8 3.5 8 7.9s-3.5 7.9-8 7.9c-4.4 0-8-3.5-8-7.9s3.6-7.9 8-7.9zm-4.1 7.8c0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4c-2.1.1-4 1.8-4 4zM167.9 0c4.4 0 8 3.5 8 7.9s-3.5 7.9-8 7.9c-4.4 0-8-3.5-8-7.9s3.7-7.9 8-7.9zm-4 7.8c0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4c-2.2.1-4 1.8-4 4zm21.9 2.1L181 .3h-3.4v15.1h3.6V8.8l3.6 6.7h2.1l3.6-6.7v6.7h3.6V.3h-3.4l-4.9 9.6z" /></svg>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FooterLinkItem path={ROUTES.POLICIES.LEGAL_INFORMATION} isSmall={true}>{translate("footer.more.legal_information")}</FooterLinkItem>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FooterLinkItem path={ROUTES.POLICIES.TERMS_CONDITION} isSmall={true}>{translate("footer.more.terms_use")}</FooterLinkItem>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FooterLinkItem path={ROUTES.POLICIES.PRIVACY_POLICY} isSmall={true}>{translate("footer.more.privacy_policy")}</FooterLinkItem>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FooterLinkItem onClick={handleCookieClick} isSmall={true}>{translate("footer.more.cookie")}</FooterLinkItem>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== accessibilityDeclarationUrl) {
    t8 = Boolean(accessibilityDeclarationUrl) && <FooterLinkItem path={String(accessibilityDeclarationUrl)} isSmall={true}>{translate("footer.more.accessibility_declaration")}</FooterLinkItem>;
    $[11] = accessibilityDeclarationUrl;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== specificCountryUrl) {
    t9 = Boolean(specificCountryUrl) && <FooterLinkItem path={String(specificCountryUrl)} isSmall={true}>{translate("footer.more.country_specific_policies")}</FooterLinkItem>;
    $[13] = specificCountryUrl;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== apprenticeshipAgreementUrl) {
    t10 = Boolean(apprenticeshipAgreementUrl) && <FooterLinkItem path={String(apprenticeshipAgreementUrl)} isSmall={true}>{translate("footer.more.apprenticeship_agreement")}</FooterLinkItem>;
    $[15] = apprenticeshipAgreementUrl;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FooterLinkItem path={ROUTES.SECURITY.SECURITY_PAGE} isSmall={true}>{translate("security_page.title-1.security")}</FooterLinkItem>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t12 = <div>{t3}<List>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</List></div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp(e) {
  e.preventDefault();
  window.truste?.eu?.clickListener();
}